import { clsx } from 'clsx';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Button size. Defaults to `normal`. */
  size?: 'small' | 'normal';

  /** When using the button over dark backgrounds. */
  inverted?: boolean;
}

export function TextButton({
  inverted,
  className,
  size = 'normal',
  ...props
}: ButtonProps) {
  const sizes = {
    small: 'text-sm py-1.5',
    normal: 'text-base py-2'
  };

  const classes = clsx(
    'font-sans font-semibold underline',
    // hover state
    'hover:no-underline',
    // focus state
    'focus:border focus:border-action focus:rounded focus:no-underline',
    // light/dark classes
    inverted ? 'text-white' : 'text-action',
    // size classes,
    sizes[size],
    // additional classes
    className
  );

  return <button className={classes} {...props} />;
}
